const unallocatedTime = 0;

export { unallocatedTime as default };
